import { StreamingPlayerView, StreamingPlayerWidgetLayout } from '@heardis/stream-contracts';
import loggerService from './logger';

export function getWidgetLayout(): StreamingPlayerWidgetLayout {
  const params = new URL(window.location?.href).searchParams;
  const layout = params.get('layout');

  if (!layout) return StreamingPlayerWidgetLayout.REGULAR;

  switch (layout) {
    case StreamingPlayerWidgetLayout.SMALL:
      return StreamingPlayerWidgetLayout.SMALL;
    case StreamingPlayerWidgetLayout.REGULAR:
      return StreamingPlayerWidgetLayout.REGULAR;
    case StreamingPlayerWidgetLayout.LARGE:
      return StreamingPlayerWidgetLayout.LARGE;
    default:
      loggerService.info(`We use the ${StreamingPlayerWidgetLayout.REGULAR} layout, because this layout is unknown:`, layout);
      return StreamingPlayerWidgetLayout.REGULAR;
  }
}

export function getView(): StreamingPlayerView {
  const params = new URL(window.location?.href).searchParams;
  const view = params.get('view');

  if (!view) return StreamingPlayerView.FULL;

  switch (view) {
    case StreamingPlayerView.WIDGET:
      return StreamingPlayerView.WIDGET;
    case StreamingPlayerView.FULL:
      return StreamingPlayerView.FULL;
    default:
      loggerService.info(`We use the ${StreamingPlayerView.FULL} view, because this view is unknown:`, view);
      return StreamingPlayerView.FULL;
  }
}
